import { EddaBankInfo } from '@/interface/KKC/edda';
import {
  AppPayOrderBillDTO,
  AppPayOrderDetailDTO,
  LittleBank,
  LoanDto,
  OverDueDto,
  PaymentBankFlowDTO,
  RepayImmediateResult,
  RepaymentBillFlushRecordDto,
} from '@/interface/KKC/repayment';
import { repaymentPlanList } from '@/interface/KKC/withdrawal';
import { clRequest } from '@/utils/request';
import request, { Options } from '@web/common/src/utils/requests/request';

// 查询还款展示列表
export const getRepaymentList = (type: string, productCode: string, option?: Options) =>
  request.get<LoanDto[]>(
    `/credit/repayment/listUserPayOrders`,
    {
      params: { type, productCode },
    },
    option
  );

// 查询edda绑定的卡信息
export const selectCardInfo = (fillInItems?: any, options?: Options) =>
  request.post<Array<EddaBankInfo>>('credit/binding/selectCardInfo', fillInItems, options);

// 查询是否提現有禁申期
export const checkShowUP = (data: { productCode: string }) =>
  request.post('credit/layout-check/hasLockInfo', data, { hideError: true });

// 获取贷款详情
export const payOrderDetail = (orderId: string) =>
  request.get<{
    appPayOrderDetailDTO: AppPayOrderDetailDTO;
    paymentBankFlowDTOS: PaymentBankFlowDTO[];
  }>(`/credit/repayment/payOrderDetail?orderId=${orderId}`);

// 用户主动偿还逾期账单
export const settleFirstOverDueBill = (params: {
  cardId: string;
  orderId: string;
  billId?: string;
  linkFrom?: string;
}) => request.post<string>('/credit/repayment/settleFirstOverDueBill', params);

// 用户主动偿还逾期账单
export const settleFirstOverDueBillCL = (params: {
  cardId: string;
  orderId: string;
  billId?: string;
}) => clRequest.post<string>('/credit/repayment/settleFirstOverDueBill', params);

// 查询单子是否处于还款中
export const isRepaying = (repaymentNo: string) =>
  request.get<RepayImmediateResult>(`credit/repayment/isRepaying?repaymentNo=${repaymentNo}`);

// 免息期提前一次性结清
export const settleBillsWithoutInterest = (params: {
  cardId: string;
  orderId: string;
  couponIdList: string[] | string;
}) => request.post<string>('/credit/repayment/settleBillsWithoutInterest', params);

// KKC立即还款，单期结清
export const earlySettlementCurrentPeriod = (params: {
  cardId: string;
  orderId: string;
  billId: string;
  couponIdList: string[] | string;
}) => request.post<string>('/credit/repayment/earlySettlementCurrentPeriod', params);

// CL立即还款，单期结清
export const earlySettlementCurrentPeriodCL = (params: {
  cardId: string;
  orderId: string;
  billId?: string;
}) => clRequest.post<string>('/credit/repayment/earlySettlementCurrentPeriod', params);

// 查询银行列表
export const selectBankInfo = () =>
  request.post<{
    bankAll: LittleBank[];
    bankCommon: LittleBank[];
  }>('/credit/binding/selectBankInfo');

// 查询详情的时候需要展示的字段
export const firstOverDueBill = (orderId: string) =>
  request.get<OverDueDto>(`/credit/repayment/firstOverDueBill?orderId=${orderId}`);

export const selectPdf = (orderId: string) =>
  request.post<{ pdfUrl: string; jpgUrl: string[] }>('/user/pay/selectPdf', { orderId });

// 查询详情的时候需要展示的字段
export const repaymentPlanByOrderId = (orderId: string, userId: string) =>
  clRequest.post<repaymentPlanList>('/credit/clPay/repaymentPlanByOrderId', { orderId, userId });

// KKC 点击提前按钮结清校验
export const checkIsCanEarlySettlement = (params: { billId: string; orderId: string }) =>
  request.post<string>('/credit/repayment/checkIsCanEarlySettlement', params);

export const queryOtherFile = (params: { orderId: string }) =>
  request.post<RepaymentBillFlushRecordDto[]>('/credit/repayment/selectOtherFile', params);

export const queryRefundCommission = (params: { orderId: string }) =>
  request.post<RepaymentBillFlushRecordDto[]>('/credit/repayment/selectBackCommission', params);

export const selectToRepayInAdvance = (params: { orderId: string; billId?: string }) =>
  request.post<AppPayOrderBillDTO>('/credit/repayment/selectTodoRepaymentInfo', params);

export const checkBankNum = (params: { bankCardNumEncrypt: string }) =>
  request.post('/credit/clPay/checkBankNum', params, { hideError: true });

export const earlySettlementApply = (params: {
  orderId: string;
  repaymentReasonList: string[];
  sourceFundList: string[];
  repaymentReasonOther?: string;
  sourceFundOther?: string;
}) => request.post('/credit/repayment/earlySettlementApply', params);

export const queryIsRepaying = (params: { orderId: string }) =>
  request.get<boolean>(`/credit/repayment/payOrder/isRepaying?orderId=${params.orderId}`);

// 查询是否存在催收记录
export const collectionExist = (params: { orderId: string }) =>
  request.get<boolean>(`/credit/repayment/collection/exist?orderId=${params.orderId}`);
